export default [
  {
    key: "forwardhead",
    name: "头前倾",
    definition: {
      name: "定义",
      list: ["头前倾指人体处于自然站姿、坐姿时，头相对于躯干处于异常前倾位。常见于久坐的学生、办公室人群。"]
    },
    triggerreason: {
      name: "引发原因",
      list: [
        "1、长期伏案。工作长时间对着电脑习惯性的出现头部往前伸。",
        "2、习惯性低头看手机。低头看手机，即所谓的‘低头族’也是导致头部前倾的主要诱发原因。",
      ]
    },
    danger: {
      name: "危害",
      list: [
        '1、头晕头痛：头部前倾可能影响头部血液循环，由于血流不畅而导致头部缺氧，引发头晕头痛。',
        '2、颈椎病：由于头部异位导致颈部软组织、骨骼的异常，增大了颈椎病患病风险。',
        '3、心脑血管疾病：头部的异位可能影响头部血液循环，危害心脑血管健康。',
      ],
    }
  },
  {
    key: "lateralhead",
    name: "头侧倾",
    definition: {
      name: "定义",
      list: ["头侧倾指人体处于自然站姿、坐姿时，头过度偏向单侧的异常姿态。主要诱因是左右两侧肩颈肌肉力量失衡，多由于习惯性的错误姿态导致"]
    },
    triggerreason: {
      name: "引发原因",
      list: [
        "1、习惯性使用单侧肩颈部肌肉：坐、卧时，颈部多只单向一边侧，造成左右两侧肩颈肌力不平衡",
      ]
    },
    danger: {
      name: "危害",
      list: [
        '1、肌肉韧带慢性劳损：长期头侧倾容易导致颈后韧带以及肌肉韧带慢性劳损。',
        '2、颈椎病：由于头部异位导致颈部软组织、骨骼的异常，增大了颈椎病患病风险。',
      ],
    }
  },
  {
    key: "unevenshoulder",
    name: "高低肩",
    definition: {
      name: "定义",
      list: ["高低肩指左右两侧肩部在人体自然放松状态下、竖直高度不一致的情况。通常高低肩多伴随脊柱姿态的异常。"]
    },
    triggerreason: {
      name: "引发原因",
      list: [
        "1、单侧受力过重：例如长期单侧背包或提重物。",
        "2、长期错误坐姿：翘二郎腿久坐、伏案工作时趴桌等不良习惯导致。",
      ]
    },
    danger: {
      name: "危害",
      list: [
        '1、腰痛：（高低肩）可能造成骨盆的移位，使腰部左右两侧肌力不平衡，导致腰痛。',
        '2、骨刺：高低肩使颈椎受力异常，最后可能导致颈椎部位退化，易形成骨刺。',
      ],
    }
  },
  {
    key: "roundedshoulder",
    name: "圆肩",
    definition: {
      name: "定义",
      list: ["圆肩，指从侧面观察人体，肩部呈现向双肩向前、向内收的状态。多伴随驼背。常见于学生、办公室工作人群"]
    },
    triggerreason: {
      name: "引发原因",
      list: [
        "1、习惯性姿态不佳：如含胸驼背，不规范的侧卧，侧躺等。",
        "2、胸背部肌肉力量不平衡：胸大肌相对背部肌肉力量薄弱。",
      ]
    },
    danger: {
      name: "危害",
      list: [
        '1、心脏负担加重：过度圆肩会使横膈膜处于紧张状态，造成大动脉和腔静脉被压迫，使心脏工作负担加重。',
        '2、神经被压迫：肩颈周围肌肉紧张，严重时可致颈椎神经被压迫，引起头痛、手臂麻木。',
      ],
    }
  },
  {
    name: "脊柱异位",
    key: "scoliosis",
    definition: {
      name: "定义",
      list: ["脊柱位置出现异常，通过影像检查，可能发现脊柱侧弯等脊柱非正直状态。异常可分为先天及后天性。后天性异常与习惯性姿态错误有关。"]
    },
    triggerreason: {
      name: "引发原因",
      list: [
        "1、单侧受力过重：例如长期单侧背包或提重物。",
        "2、长期错误坐姿：翘二郎腿久坐、伏案工作时趴桌等不良习惯导致。",
        "3、先天原因：由先天性导致的脊柱异位。",
      ]
    },
    danger: {
      name: "危害",
      list: [
        '1、腰椎间盘突出。',
        '2、腰痛：可能造成骨盆的移位，使腰部左右两侧肌力不平衡，导致腰痛。',
        '3、长短腿。',
      ],
    }
  },
  {
    name: "骨盆侧倾",
    key: "unevenhip",
    definition: {
      name: "定义",
      list: ["骨盆侧倾指左右两侧髋部高度差异较大，呈现骨盆歪斜的状态。多伴随脊柱位置异常、高低肩。"],
    },
    triggerreason: {
      name: "引发原因",
      list: [
        "1、长期错误坐姿：翘二郎腿久坐、伏案工作时趴桌等不良习惯导致。",
        "2、先天性长短腿：由于先天性长短腿而导致的骨盆侧倾。",
        "3、两侧下肢体态不平衡：例如，一只脚有扁平足而另一只没有，或程度不相同；两侧均有膝超伸现象，但程度不同。",
      ]
    },
    danger: {
      name: "危害",
      list: [
        '1、腰椎间盘突出。',
        '2、慢性疼痛：骨盆侧倾可能会引发腰腿疼痛、肩颈疼痛。',
        '3、长短腿。 ',
      ],
    }
  },
  {
    name: "O型腿",
    key: "oleg",
    definition: {
      name: "定义",
      list: ["人体正常姿态站立，两脚并拢时内侧脚踝可贴紧而双膝内侧无法贴紧、甚至缝隙很大，腿间呈现“O“形状。此类腿型与日常姿态习惯有关，少儿出现O型腿也可能与佝偻病有关。"]
    },
    triggerreason: {
      name: "引发原因",
      list: [
        "1、习惯性不良姿势如：骨盆后倾、足内翻倾向。",
        "2、肌肉力量不平衡如：髋外旋肌过紧。",
      ]
    },
    danger: {
      name: "危害",
      list: [
        '1、 内侧半月板损伤：O型腿造成下肢力线发生改变，膝关节内侧间隙承受大于正常负荷的压力。可能引起膝关节内侧半月板损伤。',
        '2、关节炎：严重（O型腿）最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节置换手术"。',
      ],
    }
  },
  {
    name: "X型腿",
    key: "xleg",
    definition: {
      name: "定义",
      list: ['人体正常姿态站立，双腿并拢时内侧膝可贴紧而两侧脚踝内侧无法贴紧、甚至缝隙很大，腿间呈现“X"形状。此类腿型与日常姿态习惯、肌力失衡有关。']
    },
    triggerreason: {
      name: "引发原因",
      list: [
        "1、习惯性不良姿势如：骨盆前倾、足外翻倾向。",
        "2、肌肉力量不平衡如：髋内旋肌过紧。",
      ]
    },
    danger: {
      name: "危害",
      list: [
        '1、 外侧半月板损伤：X型腿造成下肢力线发生改变，膝关节外侧间隙承受大于正常负荷的压力。可能引起膝关节外侧半月板损伤。',
        '2、关节炎：严重（X型腿）最终可能发展为膝关节骨性关节炎、关节外侧间隙关节退变，严重者需要进行人工关节置换手术。',
      ],
    }
  },
  {
    name: "膝过伸",
    key: "kneehyperextension",
    definition: {
      name: "定义",
      list: ['膝过伸，也称“膝反弓”。从人体侧面观，可见腿部呈现出向后侧弯曲、膝盖内凹、小腿相较大腿过度前伸。此种体态常见于芭蕾舞演员、以及大腿肌力薄弱者。']
    },
    triggerreason: {
      name: "引发原因",
      list: [
        "1、错误的发力姿势：站立时主要重量落在前脚掌。",
        "2、足底筋膜紧张：可能由于长期穿高跟鞋导致。",
        "3、膝关节周围肌肉力量薄弱、大腿前后侧肌力不足。",
      ]
    },
    danger: {
      name: "危害",
      list: [
        '1、膝关节畸形：长期膝关节过伸，可导致骨关节退变的发生率明显升高，会引起膝关节的过度磨损，造成关节畸形。',
        '2、全身平衡受损：髋膝踝三关节之间有着很大的位置、功能联系，膝关节位置的改变会影响其下方的踝关节位置与上方的髋关节、骨盆的位置，逐渐损害全身的平衡状态，长期会引发各种疼痛。',
      ],
    }
  },
]